// Coach Onboarding Guide — theme + step definitions (web).
// Texts live in i18n (guide.theme.<key>.*). Each step points its spotlight at a
// stable data-testid already present in the app (robust: nav items + known
// field/CTA testids). If a target isn't on screen the overlay falls back to a
// centered tooltip, so the guide never breaks.

export const GUIDE_THEMES = [
  {
    key: "profile",
    steps: [
      { target: '[data-testid="app-nav-profile"]', navigate: "/app/coach/profile", primary: "navigate" },
      { target: '[data-testid="prof-photo-pick"]', primary: "next" },
      { target: '[data-testid="prof-name"]', primary: "next" },
      { target: '[data-testid="prof-bio"]', primary: "next" },
      { target: '[data-testid="prof-save"]', primary: "finish" },
    ],
  },
  {
    key: "offering",
    steps: [
      { target: '[data-testid="app-nav-offerings"]', navigate: "/app/coach/offerings", primary: "navigate" },
      { target: null, primary: "finish" },
    ],
  },
  {
    key: "circle",
    steps: [
      { target: '[data-testid="app-nav-circles"]', navigate: "/app/coach/circles", primary: "navigate" },
      { target: null, primary: "finish" },
    ],
  },
  {
    key: "availability",
    steps: [
      { target: '[data-testid="app-nav-availability"]', navigate: "/app/coach/availability", primary: "navigate" },
      { target: null, primary: "finish" },
    ],
  },
  {
    key: "payments",
    steps: [
      { target: '[data-testid="app-nav-earnings"]', navigate: "/app/coach/earnings", primary: "navigate" },
      { target: '[data-testid="earn-stripe"]', primary: "stripe" },
    ],
  },
  {
    key: "post",
    steps: [
      { target: '[data-testid="app-nav-feed"]', navigate: "/app/feed", primary: "navigate" },
      { target: null, primary: "finish" },
    ],
  },
  {
    key: "method",
    steps: [
      { target: '[data-testid="app-nav-methods"]', navigate: "/app/coach/methods", primary: "navigate" },
      { target: null, primary: "finish" },
    ],
  },
  {
    key: "weekly_plan",
    steps: [
      { target: '[data-testid="app-nav-plans"]', navigate: "/app/coach/plans", primary: "navigate" },
      { target: null, primary: "finish" },
    ],
  },
  {
    key: "calendar",
    steps: [
      { target: '[data-testid="app-nav-availability"]', navigate: "/app/coach/availability", primary: "outlook", secondary: "skip" },
    ],
  },
  {
    key: "discover",
    steps: [
      { target: '[data-testid="app-nav-dashboard"]', navigate: "/app", primary: "navigate" },
      { target: '[data-testid="app-nav-pulse"]', primary: "next" },
      { target: '[data-testid="app-nav-messages"]', primary: "next" },
      { target: '[data-testid="app-nav-circles"]', primary: "next" },
      { target: '[data-testid="app-nav-account"]', primary: "finish" },
    ],
  },
];

export const THEME_KEYS = GUIDE_THEMES.map((t) => t.key);
export const THEME_BY_KEY = Object.fromEntries(GUIDE_THEMES.map((t) => [t.key, t]));
